import OnlyHeader from "components/Layout/OnlyHeader";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Row,
  Container,
  Card,
  CardHeader,
  Col,
  Label,
  Input,
  Button,
  Spinner,
} from "reactstrap";
import {
  updateDeliveryDays,
  addDeliveryDays,
  updatePickUpDays,
  addPickUpDays,
} from "store/actions/settingAction";
import { getRestaurantsAction } from "store/actions/restaurantAction";

function PickupOrDelivery() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { uid, user } = useSelector((state) => state.auth);
  const { pickupLoading, deliveryLoading } = useSelector(
    (state) => state.setting
  );
  const { restaurantsDetail, restaurantMedia } = useSelector((state) => state.restaurant);
  const [pickupData, setPickUpData] = useState({ startTime: "", endTime: "" });
  const [deliveryData, setDeliveryData] = useState({
    startTime: "",
    endTime: "",
  });
  const [selectedPickUpDays, setSelectedPickUpDays] = useState([]);
  const [selectedDeliveryDays, setSelectedDeliveryDays] = useState([]);
  const [pickupChanged, setPickupChanged] = useState(false);
  const [deliveryChanged, setDeliveryChanged] = useState(false);
  const days = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

   useEffect(() => {
      if (user?.restaurantID) {
        dispatch(getRestaurantsAction(user?.restaurantID));
      }
    }, [user?.restaurantID, dispatch]);


  const handlePickUpChange = (e) => {
    setPickUpData({ ...pickupData, [e.target.name]: e.target.value });
  };

  const handleDeliveryChange = (e) => {
    setDeliveryData({ ...deliveryData, [e.target.name]: e.target.value });
  };

  const handlePickUpDayClick = (day) => {
    setSelectedPickUpDays((prev) =>
      prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
    );
  };

  const handleDeliveryDayClick = (day) => {
    setSelectedDeliveryDays((prev) =>
      prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
    );
  };

  const toMinutes = (timeStr) => {
    if (!timeStr) return null;
    const [hours, minutes] = timeStr.split(":").map(Number);
    return hours * 60 + minutes;
  };

  const handlePickUp = () => {
    const { startTime, endTime } = pickupData;
    const startMinutes = toMinutes(startTime);
    const endMinutes = toMinutes(endTime);

    if (startMinutes === null || endMinutes === null) {
      toast.error("Please enter both pickup start and end time");
      return;
    }

    if (startMinutes === endMinutes) {
      toast.error("Pickup start & end time cannot be the same");
      return;
    }

    if (endMinutes <= startMinutes) {
      toast.error("Pickup end time must be after start time");
      return;
    }

    const invalidDays = [];

    selectedPickUpDays.forEach((day) => {
      const storeDay = restaurantsDetail?.storeTiming?.find((d) => d.day === day);

      if (!storeDay || !storeDay.startTime || !storeDay.endTime) {
        invalidDays.push(`${day} (store timings missing)`);
        return;
      }

      const storeStart = toMinutes(storeDay.startTime);
      const storeEnd = toMinutes(storeDay.endTime);

      if (startMinutes < storeStart) {
        invalidDays.push(`${day}`);
      }

      if (endMinutes > storeEnd) {
        invalidDays.push(`${day}`);
      }
    });

    if (invalidDays.length > 0) {
      toast.error(`Set delivery and pickup timing according to the store timings.`);
      return;
    }

    if (user?.pickupDays) {
      dispatch(updatePickUpDays(uid, selectedPickUpDays, pickupData));
    } else {
      dispatch(addPickUpDays(uid, selectedPickUpDays, pickupData));
    }
  };

  const handleDelivery = () => {
    const { startTime, endTime } = deliveryData;
    const startMinutes = toMinutes(startTime);
    const endMinutes = toMinutes(endTime);

    if (startMinutes === null || endMinutes === null) {
      toast.error("Please enter both delivery start and end time");
      return;
    }

    if (startMinutes === endMinutes) {
      toast.error("Delivery start & end time cannot be the same");
      return;
    }

    if (endMinutes <= startMinutes) {
      toast.error(
        "Delivery end time must be after start time (on the same day)"
      );
      return;
    }

    const invalidDays = [];

    selectedDeliveryDays.forEach((day) => {
      const storeDay = restaurantsDetail?.storeTiming?.find((d) => d.day === day);

      if (!storeDay || !storeDay.startTime || !storeDay.endTime) {
        invalidDays.push(`${day} (store timings missing)`);
        return;
      }

      const storeStart = toMinutes(storeDay.startTime);
      const storeEnd = toMinutes(storeDay.endTime);

      if (startMinutes < storeStart) {
        invalidDays.push(`${day} `);
        return;
      }

      if (endMinutes > storeEnd) {
        invalidDays.push(`${day}`);
      }
    });

    if (invalidDays.length > 0) {
      toast.error(`Set delivery and pickup timing according to the store timings.`);
      return;
    }

    if (user?.deliveryDays) {
      dispatch(updateDeliveryDays(uid, selectedDeliveryDays, deliveryData));
    } else {
      dispatch(addDeliveryDays(uid, selectedDeliveryDays, deliveryData));
    }
  };

  useEffect(() => {
    if (user?.pickupDays) {
      let temp = [];
      for (let i = 0; i < user.pickupDays.length; i++) {
        temp.push(user.pickupDays[i].day);
      }
      setSelectedPickUpDays(temp);
      setPickUpData({
        startTime: user.pickupDays[0]?.startTime || "",
        endTime: user.pickupDays[0]?.endTime || "",
      });
    }

    if (user?.deliveryDays) {
      let temp = [];
      for (let i = 0; i < user.deliveryDays.length; i++) {
        temp.push(user.deliveryDays[i].day);
      }
      setSelectedDeliveryDays(temp);
      setDeliveryData({
        startTime: user.deliveryDays[0]?.startTime || "",
        endTime: user.deliveryDays[0]?.endTime || "",
      });
    }
  }, [user]);

  useEffect(() => {
    if (!user?.pickupDays) {
      setPickupChanged(
        selectedPickUpDays.length > 0 &&
          pickupData.startTime &&
          pickupData.endTime
      );
    } else {
      const originalDays = user.pickupDays.map((d) => d.day);
      const originalStart = user.pickupDays[0]?.startTime;
      const originalEnd = user.pickupDays[0]?.endTime;

      const daysChanged =
        JSON.stringify(selectedPickUpDays.sort()) !==
        JSON.stringify(originalDays.sort());
      const timesChanged =
        pickupData.startTime !== originalStart ||
        pickupData.endTime !== originalEnd;

      setPickupChanged(
        (daysChanged || timesChanged) &&
          selectedPickUpDays.length > 0 &&
          pickupData.startTime &&
          pickupData.endTime
      );
    }
  }, [selectedPickUpDays, pickupData, user]);

  useEffect(() => {
    if (!user?.deliveryDays) {
      setDeliveryChanged(
        selectedDeliveryDays.length > 0 &&
          deliveryData.startTime &&
          deliveryData.endTime
      );
    } else {
      const originalDays = user.deliveryDays.map((d) => d.day);
      const originalStart = user.deliveryDays[0]?.startTime;
      const originalEnd = user.deliveryDays[0]?.endTime;
      const daysChanged =
        JSON.stringify(selectedDeliveryDays.sort()) !==
        JSON.stringify(originalDays.sort());
      const timesChanged =
        deliveryData.startTime !== originalStart ||
        deliveryData.endTime !== originalEnd;
      setDeliveryChanged(
        (daysChanged || timesChanged) &&
          selectedDeliveryDays.length > 0 &&
          deliveryData.startTime &&
          deliveryData.endTime
      );
    }
  }, [selectedDeliveryDays, deliveryData, user]);

  return (
    <>
      <OnlyHeader />
      <Container fluid className="mt--7">
        <div className="col">
          <Card className="shadow">
            <CardHeader className="d-lg-flex d-sm-block justify-content-between">
              <div className="d-flex align-items-center">
                <Button
                  size="sm"
                  color="primary"
                  onClick={() =>
                    history.push("/admin/settings/venue-setting-menu")
                  }
                >
                  <i className="fas fa-arrow-left "></i>
                </Button>
                <h3 className="pt-2">Pickup & Delivery Schedule</h3>
              </div>
            </CardHeader>
            <Container className="mb-4">
              <Label className="mt-3 ml-3">
                <strong>Pickup :</strong>
              </Label>
              <Row className="mx-3 my-3">
                <Col className="px-0">
                  <Label>Pickup Days</Label>
                  <Row className="mx-3 d-flex flex-wrap justify-content-start">
                    {days.map((day, idx) => (
                      <Button
                        key={idx}
                        size="sm"
                        className="text-capitalize m-1"
                        style={{
                          background: selectedPickUpDays.includes(day)
                            ? restaurantMedia?.adminColor || "rgb(215, 3, 101)"
                            : "#d1d5db",
                          color: selectedPickUpDays.includes(day)
                            ? "#ffffff"
                            : "#000000",
                        }}
                        onClick={() => handlePickUpDayClick(day)}
                      >
                        {day}
                      </Button>
                    ))}
                  </Row>
                </Col>
              </Row>
              <Row className="mx-1 my-3">
                <Col xs="12" md="6" className="mb-2">
                  <Label>Start Time</Label>
                  <Input
                    type="time"
                    name="startTime"
                    step="60"
                    value={pickupData.startTime}
                    onChange={handlePickUpChange}
                  />
                </Col>
                <Col xs="12" md="6">
                  <Label>End Time</Label>
                  <Input
                    type="time"
                    name="endTime"
                    step="60"
                    value={pickupData.endTime}
                    onChange={handlePickUpChange}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="d-flex mt-3 mr-3">
                  <Button
                    color="primary"
                    disabled={
                      pickupLoading ||
                      selectedPickUpDays.length === 0 ||
                      !pickupData.startTime ||
                      !pickupData.endTime ||
                      (user?.pickupDays && !pickupChanged)
                    }
                    className="ml-auto"
                    onClick={handlePickUp}
                  >
                    {pickupLoading ? <Spinner size="sm" /> : "Save"}
                  </Button>
                </Col>
              </Row>

              <Label className="mt-3 ml-3">
                <strong>Delivery :</strong>
              </Label>
              <Row className="mx-3 my-3">
                <Col className="px-0">
                  <Label>Delivery Days</Label>
                  <Row className="mx-3 d-flex flex-wrap justify-content-start">
                    {days.map((day, idx) => (
                      <Button
                        key={idx}
                        size="sm"
                        className="text-capitalize m-1"
                        style={{
                          background: selectedDeliveryDays.includes(day)
                            ? restaurantMedia?.adminColor || "rgb(215, 3, 101)"
                            : "#d1d5db",
                          color: selectedDeliveryDays.includes(day)
                            ? "#ffffff"
                            : "#000000",
                        }}
                        onClick={() => handleDeliveryDayClick(day)}
                      >
                        {day}
                      </Button>
                    ))}
                  </Row>
                </Col>
              </Row>
              <Row className="mx-1 my-3">
                <Col xs="12" md="6" className="mb-2">
                  <Label>Start Time</Label>
                  <Input
                    type="time"
                    name="startTime"
                    step="60"
                    value={deliveryData.startTime}
                    onChange={handleDeliveryChange}
                  />
                </Col>
                <Col xs="12" md="6">
                  <Label>End Time</Label>
                  <Input
                    type="time"
                    name="endTime"
                    step="60"
                    value={deliveryData.endTime}
                    onChange={handleDeliveryChange}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="d-flex mt-3 mr-3">
                  <Button
                    color="primary"
                    disabled={
                      deliveryLoading ||
                      selectedDeliveryDays.length === 0 ||
                      !deliveryData.startTime ||
                      !deliveryData.endTime ||
                      (user?.deliveryDays && !deliveryChanged)
                    }
                    className="ml-auto"
                    onClick={handleDelivery}
                  >
                    {deliveryLoading ? <Spinner size="sm" /> : "Save"}
                  </Button>
                </Col>
              </Row>
            </Container>
          </Card>
        </div>
      </Container>
    </>
  );
}

export default PickupOrDelivery;
